'use client';
import { Box, Typography } from '@mui/material';

import { ComponentErrorBoundary } from '@/components';
import { useT } from '@/hooks';

interface SearchPageHeaderProps {
  count: number;
  query: string;
}

export function SearchPageHeader({ count, query }: SearchPageHeaderProps) {
  const { t } = useT();
  return (
    <ComponentErrorBoundary componentName="SearchResultsHeader">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 4,
          mt: { xs: 2, lg: 0 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.25rem', md: '1.75rem' },
              fontWeight: 700,
              color: 'text.secondary',
            }}
          >
            {count}
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.25rem', md: '1.75rem' },
              fontWeight: 400,
              color: 'text.secondary',
            }}
          >
            {t('common.resultsFor')}
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.25rem', md: '1.75rem' },
              fontWeight: 700,
              color: 'text.primary',
            }}
          >
            "{query}"
          </Typography>
        </Box>
      </Box>
    </ComponentErrorBoundary>
  );
}
